const DEFAULT_PRIMARY_COLOR = '#1BB4EB';

export type WhiteLabelOrganization = {
  logo?: string;
  primaryColor?: string;
  secondaryColor?: string;
  [key: string]: unknown;
};

export const getWhiteLabelOrganization = (): WhiteLabelOrganization | null => {
  try {
    const raw = localStorage.getItem('white_label');
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as WhiteLabelOrganization;
  } catch {
    return null;
  }
};

export const getWhiteLabelPrimaryColor = (): string => {
  const primaryColor = getWhiteLabelOrganization()?.primaryColor;
  return typeof primaryColor === 'string' && primaryColor.length > 0
    ? primaryColor
    : DEFAULT_PRIMARY_COLOR;
};

/** Persist org branding used by theme, logo, and feature flags. */
export const persistWhiteLabelOrganization = (
  organization: WhiteLabelOrganization | null | undefined
): void => {
  if (!organization || typeof organization !== 'object') {
    return;
  }

  localStorage.setItem('white_label', JSON.stringify(organization));
};
